import { Navigate, useLocation } from "react-router-dom";
import LegacyRedirector from "./LegacyRedirector";

const RootRouteHandler = () => {
  const location = useLocation();

  if (location.hash.endsWith("@")) {
    return (
      <LegacyRedirector assumedType="funders" explicitShortName="masked" />
    );
  }

  return <Navigate to="/funders" replace />;
};

export default RootRouteHandler;
